<template>
    <div alt="agent avatar placeholder" class="ut-w-0 ut-mx-0 ut-bg-neutral-020 ut-rounded-full" />
</template>

<script>
export default {
  name: 'AvatarPlaceholder',
};
</script>

<style scoped lang="scss">
</style>
